import { render, staticRenderFns } from "./askAnExpert.vue?vue&type=template&id=0f3eeea6&scoped=true&"
import script from "./askAnExpert.vue?vue&type=script&lang=js&"
export * from "./askAnExpert.vue?vue&type=script&lang=js&"
import style0 from "./askAnExpert.vue?vue&type=style&index=0&id=0f3eeea6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3eeea6",
  null
  
)

export default component.exports